export default __webpack_public_path__ + "static/media/cheron-updown.fce34246.svg";